/* This file was automatically generated - please modify the template not this file! */

import * as React from "react";
import { ThunkDispatch } from "redux-thunk";
import { connect } from "react-redux";

import { ConfirmedButton } from "@teamprevent/common/confirmedButton/ConfirmedButton";

import { AppState } from "../model";
import { deleteTextSnippet } from "../actions";
import { basePathSelector } from "../selectors";

interface MergedProps {
    delete: () => void;
}

class DeleteButton extends React.Component<MergedProps> {
    public render() {
        return (
            <ConfirmedButton
                icon="delete"
                content="Delete"
                floated="left"
                className="warning"
                onClick={() => this.props.delete()}
                promptText="Are you sure you want to delete this TextSnippet? Type 'DELETE' and click confirm to delete."
                typeToConfirmText="DELETE"
                headingText="Delete TextSnippet"
            />
        );
    }
}

interface StateProps {
    id: any;
    basePath: string;
}

interface DispatchProps {
    dispatchDelete: (id: any, basePath: string) => void;
}

function mapStateToProps(state: AppState): StateProps {
    return {
        id: state.router.params.textSnippetId,
        basePath: basePathSelector(state)
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<AppState, undefined, any>): DispatchProps {
    return {
        dispatchDelete: (id, basePath) => dispatch<any>(deleteTextSnippet(id, basePath))
    };
}

function mergeProps(propsFromState: StateProps, propsFromDispatch: DispatchProps): MergedProps {
    return {
        delete: () => propsFromDispatch.dispatchDelete(propsFromState.id, propsFromState.basePath)
    };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(DeleteButton);
